module.exports = {
    gaEvent : function(a, b, c) {
        if (window.gtag && window.gtag != null) {
            window.gtag(a, b, c);
        }
    }
}